import React from "react";
import { UserMenu, Logout, AppBar } from "react-admin";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import SettingsIcon from "@mui/icons-material//Settings";
import ArrowBackIcon from "@mui/icons-material//ArrowBack";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

import { getCustomerAssociations, hasScope, SCOPE } from "./auth";
import { isProduction, getEnvironmentName } from "./appConfig";
import { bwColours } from "./theme";
import { custInfo } from "./customer";

const styles = {
  logo: {
    height: "3em",
  },
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  env: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textAlign: "right",
  },
  spacer: {
    flex: 1,
  },
};

const Logo = () => {
  return <img src="/logo192.png" alt="BarrelWise" style={styles.logo} />;
};

const ChangePasswordItem = () => (
  <MenuItem to="/changepass" component={Link}>
    <ListItemIcon>
      <SettingsIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText>Change Password</ListItemText>
  </MenuItem>
);

const ExitWinery = () => (
  <MenuItem to="/" component={Link}>
    <ListItemIcon>
      <ArrowBackIcon fontSize="small" />
    </ListItemIcon>
    <ListItemText>Exit Winery</ListItemText>
  </MenuItem>
);

const CustomUserMenu = ({ withExit }) => {
  const custs = getCustomerAssociations();
  return (
    <UserMenu>
      {withExit && (hasScope(SCOPE.ADMIN) || custs.length > 1) ? (
        <ExitWinery />
      ) : null}
      <ChangePasswordItem />
      <Logout />
    </UserMenu>
  );
};

export const CustomAppBar = () => {
  const withExit = custInfo !== undefined;
  const defaultTitle = custInfo?.customerLongName;

  return (
    <AppBar
      sx={{
        "& .RaAppBar-title": {
          flex: 1,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
        },
        background: isProduction() ? undefined : bwColours.primary.beige,
      }}
      userMenu={<CustomUserMenu withExit={withExit} />}
    >
      <Typography variant="h6" color="inherit" style={styles.title}>
        {defaultTitle ? defaultTitle + ": " : null}
        <span id="react-admin-title" />
      </Typography>
      <Logo />
      <Typography variant="h6" color="inherit" style={styles.env}>
        {isProduction() ? null : getEnvironmentName()}
      </Typography>
    </AppBar>
  );
};
